import React from 'react';
import { useTranslation } from 'react-i18next';
import { MetaToggle } from 'shared/components/ui/meta-toggle';

export type HideOnTodoToggleProps = {
  value: boolean;
  onChange: (hideOnTodo: boolean) => void;
  disabled?: boolean;
  fullWidth?: boolean;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
};

export const HideOnTodoToggle: React.FC<HideOnTodoToggleProps> = ({
  value,
  onChange,
  disabled,
  fullWidth,
  icon,
}) => {
  const { t } = useTranslation();

  return (
    <MetaToggle
      label={t('general.labels.habit.repeat.hide-on-todo.label')}
      checked={!value}
      onChange={(checked) => onChange(!checked)}
      disabled={disabled}
      fullWidth={fullWidth}
      icon={icon}
      id="hide-on-todo-toggle"
    />
  );
};
